import React from 'react';
import ScaleLoader from 'react-spinners/ScaleLoader';
import styled from 'styled-components';

const SpinContainer = styled.div`
  display: block;
  width: 100%;
`;

const SpinPosition = styled.div`
  width: 100%;
  margin: 20px auto;
  text-align: center;
`;

export default function Spinner({ center = false }) {
  const Content = (
    <ScaleLoader width={4} height={35} radius={2} margin={'2px'} />
  );
  if (center) {
    return (
      <SpinContainer>
        <SpinPosition>{Content}</SpinPosition>
      </SpinContainer>
    );
  }

  return Content;
}
